import React,{Component} from 'react'
import enhanceWithClickOutside from 'react-click-outside'
import shallowequal from 'shallowequal'
import './style.css'

class EditableText extends Component{
    constructor(props){
        super(props)

        this.state = {
            value:props.value,
            isEditing:false,
            error:false
        }

    }
    //TODO пробрасывать свойства при изменении
    componentWillReceiveProps(newProps){
        if(!shallowequal(newProps,this.props)){
            this.setState({
                ...this.state,
                value:newProps.value
            })
        }
    }

    handleOnClick(e){
       e.stopPropagation()
        this.setState({
            isEditing:true,
            value: this.state.value !== null ? this.state.value : ""
        })
    }
    handleClickOutside() {
        if(this.state.isEditing){
            this.funcSave(this.state.value !== this.props.value)
        }
    }
    handleChange(value){
        this.setState({
            value:value
        })
    }
    handleKeyPress(e) {

        //Enter
        if(e.key === "Enter"){
            e.target.blur();
            this.funcSave();
        }
    }

    funcSave(save = true){

        this.setState({
            isEditing:false
        })

        if(this.funcIsValid()){
            this.setState({
                error:false
            })
                if(save){
                    if(this.props.onSave !== undefined){
                        this.props.onSave(this.state.value);
                    }
                }
        }else{
            this.setState({
                error:true
            })
        }
    }
    funcIsValid(){
        //TODO дополнить другими методами
        let value = this.state.value;
       if(this.props.require === true){
           if(!value || value === null || value.length === 0){
               return false;
           }
       }
       return true;
    }


    render(){
        let value = this.props.value;
        let className = "editable-text";

        if(this.state.isEditing){
            className += " editing";
        }
        return(
            this.state.value !== null ?
                <div className={className}
                     onClick={(e)=>this.handleOnClick(e)}
                     title="Редактировать"
                >
                    {
                        this.state.error ?
                            <i className=" error-ico glyphicon glyphicon-warning-sign text-warning" title="Ошибка"></i>
                            : null
                    }
                    <input
                        title="Редактировать &#013;Предыдущее значение Ctrl + Z"
                        value={this.state.value}
                        placeholder={this.props.placeholder}
                        onChange={(e)=>this.handleChange(e.target.value)}
                        onKeyPress={(e)=>this.handleKeyPress(e)}
                    />
                    <i className="glyphicon glyphicon-pencil"></i>
                </div>
                :
                <span
                    className="label label-warning null-text"
                    onClick={(e)=>this.handleOnClick(e)}
                >
                    {this.props.nullText}
                </span>
        )
    }
}

export default enhanceWithClickOutside(EditableText)


// WEBPACK FOOTER //
// ./src/components/Shared/EditableText/index.jsx